// extracted by mini-css-extract-plugin
export default {"file":"styles_file__X838l","bin":"styles_bin__xl4WZ","download":"styles_download__7YlVt"};